import { render, staticRenderFns } from "./BulkSendFilesCardTable.vue?vue&type=template&id=34361f5c&scoped=true&lang=pug"
import script from "./BulkSendFilesCardTable.vue?vue&type=script&lang=js"
export * from "./BulkSendFilesCardTable.vue?vue&type=script&lang=js"
import style0 from "./BulkSendFilesCardTable.vue?vue&type=style&index=0&id=34361f5c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34361f5c",
  null
  
)

export default component.exports